import defaultConfig from './envs/default.env'
import local from './envs/local.env'
import dev from './envs/dev.env'
import prod from './envs/prod.env'
import {
	adminMenu,
	sidePageList,
	MenuType,
	SidePageType,
	defaultMenu,
	mobileMenuList,
	homeMenuList,
	customerSubMenuList,
	supportSubMenuList,
} from './menu.config'
import { icons } from './icon.config'
import { southKoreaDistrict, ProvinceType } from './southKoreaDistrict.config'
import { fileIcon, FileIconType } from './fileIcon.config'
import { manualUrlList } from './manual.config'

export type { MenuType, SidePageType } from './menu.config'
export type { FileIconType } from './fileIcon.config'
import { HomeNavMenuType } from '@redux/index'

const config = {
	get: (searchGroup = '') => {
		try {
			const tempEnv: string = process.env.REACT_APP_NODE_ENV ?? ''
			const env: string = tempEnv.toString().toUpperCase()
			const environment: { [key: string]: any } =
				env === 'PROD' ? prod : env === 'LOCAL' ? local : dev
			const result: { [key: string]: any } = util.merge(defaultConfig, environment)

			if (searchGroup === '') {
				return result
			} else {
				return result[searchGroup]
			}
		} catch (error) {
			console.warn(error)
		}
	},

	defaultMenu: (): MenuType => defaultMenu,

	adminMenu: (): MenuType[] => {
		const menuList: MenuType[] = adminMenu
		return menuList
	},
	sidePage: (): SidePageType[] => {
		const sidePageeList: SidePageType[] = sidePageList
		return sidePageeList
	},

	homeMenu: (): HomeNavMenuType[] => {
		const homeMenu: HomeNavMenuType[] = homeMenuList
		return homeMenu
	},

	customerMenu: (): HomeNavMenuType[] => {
		const menu: HomeNavMenuType[] = customerSubMenuList
		return menu
	},

	supportMenu: (): HomeNavMenuType[] => {
		const menu: HomeNavMenuType[] = supportSubMenuList
		return menu
	},

	mobileMenuList: mobileMenuList,

	icons: (): string[] => {
		const iconList: string[] = icons
		return iconList
	},

	province: (): string[] => {
		const totalDistrict: ProvinceType = southKoreaDistrict

		return Object.keys(totalDistrict)
	},

	city: (province = ''): string[] => {
		const totalDistrict: ProvinceType = southKoreaDistrict

		const idx = Object.keys(totalDistrict).indexOf(province)
		const cities = idx > -1 ? totalDistrict[province] : []

		return cities
	},
	fileIcon: (ext: string): FileIconType => {
		const res: FileIconType =
			ext === ''
				? {
						color: '',
						labelColor: '',
						glyphColor: '',
						mimeType: '',
				  }
				: fileIcon[ext]
		return res
	},

	manual: (code: string) => {
		const res = manualUrlList[code]
		return res
	},
}

const util = {
	isObject: (value: any) => {
		return value !== null && typeof value === 'object' && !Array.isArray(value)
	},

	merge: (
		target: { [key: string]: any },
		source: { [key: string]: any },
	): { [key: string]: any } => {
		for (const key of Object.keys(source)) {
			const targetValue: any = target[key]
			const sourceValue: any = source[key]
			if (util.isObject(targetValue) && util.isObject(sourceValue)) {
				Object.assign(
					sourceValue,
					util.merge(targetValue as object, sourceValue as object),
				)
			}
		}

		return { ...target, ...source }
	},
}

export default config
